import React from 'react';
import { Row } from 'react-bootstrap';
import ChartLiveReadings from './Charts/ChartLiveReadings';

const TabLiveReadings = ({ hirarchy }) => (
  <Row>
    <ChartLiveReadings id={hirarchy.level.value} />
  </Row>
);

export default TabLiveReadings;
